import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Edit } from "react-feather";

export const tableColumn = [
    {
        Header: "S. No",
        id: "s_no",
        width: "75",
    },
    {
        Header: "Actions",
        width:"75",
        accessor: (data) => {
            return (
                <>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Update Tpmr</Tooltip>}
                    >
                        <span>
                            <a
                                href={`/tms/batches/students-tpmr/${data?.enrolment?.id}/update-tpmr?batchId=${data?.batch_id}`}
                                target="_blank"
                                rel="noreferrer"
                                className="me-1"
                            >
                                <Edit />
                            </a>
                        </span>
                    </OverlayTrigger>
                </>
            );
        },
    },
    {
        Header: "Student Name",
        accessor: "enrolment.name",
        width: "300",
    },
    {
        Header: "Sponsor Company",
        accessor: "enrolment.sponsor_company.name",
        width: "325",
    },
    {
        Header: "Fin No",
        accessor: "enrolment.fin",
        width: "150",
    },
    {
        Header: "Trade",
        accessor: "enrolment.type_of_trade",
        width: "200",
    },
    {
        Header: "Application Opt",
        accessor: "enrolment.application_option",
        width: "200",
    },
    {
        Header: "Person-in-charge",
        accessor: "enrolment.invoice.sales_user.name",
        width: "200",
    },
    {
        Header: "TPMR Remarks",
        accessor: "student.student_tpmr.remarks",
    },
];
